import router from './router/index';
import Vue from 'vue';
import App from './App.vue';
import merge from 'webpack-merge';
import {store} from './store/store';
import {getLibraryIsPart,getLibraryInfo, menusConfigsPlatforms, menusConfigsLibrary} from './common/config';
import axios from 'axios';
import VueAxios from 'vue-axios';
import {CommonUtil} from "./common/CommonUtil";
import {StorageUtil} from "./common/Auth";
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

//设置cookie的三十分钟内是否操作的初始值
let d = new Date();
d.setTime(d.getTime() + (0.125 * 24 * 60 * 60 * 1000));
let expires = "expires=" + d.toUTCString();
document.cookie = "noMovingTime" + "=" + "true" + "; " + expires+"; path=/" ;

function getEnvironment() {
    try{
        if(opac_environment.getEnvironment()==='OPAC' || opac_environment.getEnvironment()==='OPAC-EPUB') {
            store.opacType = 1;
        }
    }catch(error) {
        store.opacType = 0;
    }
    return store.opacType;

}
let isplat = 0; /*1平台 2图书馆*/
let hallCode;
router.beforeEach((to, from, next)=>{
  if(to.matched.length === 0) {
    next('/error')
  }
  let location = window.location.host.split('.');
  let domainHallCode = location[0] && location[0]!='ytsg' && location[0]!='www' && location.indexOf('ytsg') != -1?location[0]:'';
  let path = to.path;
  hallCode = (from.query.hallCode || to.query.hallCode || domainHallCode).toUpperCase();
  store.hallCode = hallCode;
  getEnvironment();
  if(hallCode && isplat !== 1) {
    /*有馆号的情况进入图书馆网站*/
    if(!store.library) {
      /*馆信息不存在的情况下获取馆信息*/
      getLibraryInfo(hallCode,Vue).then((data)=>{
        /*获取图书馆信息成功*/
        if(!data || !data.libId || !data.libName || !data.libraryLevel) {
          isplat = 1;
          next('/'); /*获取图书馆信息失败，回到平台首页*/
          return false
        }
        data['id']=data.libId;
        data['name']=data.libName;
        store.webType = 1; /*修改配置为图书馆*/
        store.library = data;
        getLibraryIsPart(hallCode,Vue).then((data)=>{
          if (data.count>0 && store.opacType == 0){
              //如果opacType为0，则配置图书馆总分馆菜单
              store.menu = menusConfigsLibrary;
          }else if(data.count>0 && store.opacType != 0){
              //如果opacType为1，则配置opac总分馆菜单
              store.menu=[
                  {name:'首页',url:'/OPACIndex'},
                  {name:'图书', background:'bg-book',url:'/book/1'},
                  {name:'电子书', background:'bg-ebook',url:'/book/2'},
                  {name:'资讯', background:'bg-news',url:'/informationlist'},
                  {name:'活动', background:'bg-activity',url:'/activitylist'},
                  {name:'本馆介绍', background:'bg-indroduce',url:'/webintroduce'},
                  {name:'总分馆', background:'bg-library',url:'/librarypart'},
                  {name:'读者留言', background:'bg-reader',url:'/readercomments'}
              ];
              if(hallCode == "AAARA" || hallCode == "AAKBU" || hallCode == "AAKBT" || hallCode == "AAKBV" || hallCode == "AAKBX"){
                  store.menu.push({name:'学习强国', background:'bg-learnpower',url:''})
              }
          }else if(data.count<=0 && store.opacType == 0){
              //如果opacType为0，则配置图书馆菜单
              store.menu=[
                  { name: '首页',url: '/',}, { name: '本馆介绍',url: '/webintroduce',},
                  { name: '图书',url: '/book/1',}, { name: '电子书',url: '/book/2',},
                  { name: '资讯',url: '/informationlist',}, { name: '活动',url: '/activitylist',},
                  { name: '读者留言',url: '/readercomments',}
              ];
          }else{
              //如果opacType为1，则配置opac菜单
              store.menu=[
                  {name:'首页',url:'/OPACIndex'},
                  {name:'图书', background:'bg-book',url:'/book/1'},
                  {name:'电子书', background:'bg-ebook',url:'/book/2'},
                  {name:'资讯', background:'bg-news',url:'/informationlist'},
                  {name:'活动', background:'bg-activity',url:'/activitylist'},
                  {name:'本馆介绍', background:'bg-indroduce',url:'/webintroduce'},
                  {name:'读者留言', background:'bg-reader',url:'/readercomments'}
              ];
              if(hallCode == "AAARA" || hallCode == "AAKBU" || hallCode == "AAKBT" || hallCode == "AAKBV" || hallCode == "AAKBX"){
                  store.menu.push({name:'学习强国', background:'bg-learnpower',url:''})
              }
          }
          next({path:path, query:merge(to.query,{hallCode: hallCode,libId: store.library.id, libLevel: store.library.libraryLevel, libraryname: store.library.name})})
        },()=>{
            next('/') /*获取图书馆信息失败，回到平台首页*/
        })
      },()=>{
        isplat = 1;
        next('/') /*获取图书馆信息失败，回到平台首页*/
      })  /*获取图书馆信息*/
    }else if(!to.query.hallCode || !to.query.libId || !to.query.libLevel || !to.query.libraryname){
        /*馆信息存在，馆号丢失添加馆号*/
        next({
            path:path,
            query:merge(
                to.query,
                {
                    hallCode: hallCode,
                    libId: store.library.id,
                    libLevel: store.library.libraryLevel,
                    libraryname: store.library.name
                }
                )
        })
    }else {
      /*馆信息存在*/
      document.title=store.library.name;
      next()
    }
  } else {
    store.menu = menusConfigsPlatforms; /*默认配置为平台*/
    store.webType = 0;
    //store.webType = 1;
    store.library = {};
    document.title='云图书馆';
    next()
  }
});
new Vue({
  router,
  render: h => h(App),
  created(){
    document.dispatchEvent(new Event('render-event'))
  },
}).$mount('#app');
